import LeftSidebar from './LeftSidebar';
import React, { useState, useEffect } from 'react';
import Topbar from './Topbar';
import Footer from './Footer';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { BASE_URL } from '../Config';
import { MDBDataTable } from 'mdbreact';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
const Customer = () => {
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const token = localStorage.getItem('token');
const [showModal, setShowModal] = useState(false);
const [details, setDetails] = useState(null);
const [customerLoading, setCustomerLoading] = useState(false);
const handleCloseModal = () => {
    setShowModal(false);
    
};
const handleView=(customer)=>{
    //alert(customer);
    setShowModal(true);
    setCustomerLoading(true);
    axios.get(`${BASE_URL}/api/view_customer/${customer}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            setDetails(response.data.list);
           console.log(response.data.list);
           setCustomerLoading(false);
        })
        .catch(error => {
            console.error('Error fetching order details:', error);
            setCustomerLoading(false);
        });
}

  const [tableData, setTableData] = useState({
    columns: [
      { label: 'Sr.No.', field: 'serial', sort: 'asc' },
      { label: 'Name', field: 'name', sort: 'asc' },
      { label: 'Email', field: 'email', sort: 'asc' },
      { label: 'Phone', field: 'mobile', sort: 'asc' },
      { label: 'Action', field: 'action', sort: 'asc' },
    ],
    rows: [],
  });

  useEffect(() => {
    // Simulate API call
    const fetchData = async () => {

        const response = await axios.get(`${BASE_URL}/api/get_customers`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const rowsWithSerial = response.data.list.map((row, index) => ({
            serial: index + 1,
            action: (
                <button onClick={() => handleView(row.user_id)}><i className="fa fa-eye"></i></button>
              ),
            ...row,
          }));
      setTableData((prevData) => ({ ...prevData, rows: rowsWithSerial }));
    };

    fetchData();
  }, [token]);
    
 
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    return (
      <>      
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Customer Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   {
                    customerLoading ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner animation="grow" size="sm" variant="primary" />
                            <Spinner animation="grow" size="sm" variant="primary" />
                            <Spinner animation="grow" size="sm" variant="primary" />
                        </div>
                   ) : details ? (
                        <div>
                            <p className='text-black'><strong>Customer Name:</strong> {details.name}</p>
                            <p className='text-black'><strong>Email:</strong> {details.email}</p>
                            <p className='text-black'><strong>Mobile No.:</strong> {details.mobile}</p>
                            <p className='text-black'><strong>Address:</strong> {details.billing_address}</p>
                          
                        </div>
                   ) : (
                    <p>No customer details available</p>
                )}
                   
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        <div>
            <div id="page-top">
                <div id="wrapper">
                    <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                            <div className="container-fluid">
                          
                            <MDBDataTable striped bordered small data={tableData} />
         
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </div>
        </>
    );}
export default Customer;